<template>
  <router-link
    v-observe-visibility="visibilityChangedLogo"
    to="/"
    class="page-logo"
  >
    <WpImage
      key="light"
      v-if="logoImageType === 'white'"
      :data="logoTopLight"
      class="logo-image logo-light"
    />
    <WpImage
      key="dark"
      v-if="logoImageType === 'dark'"
      :data="logoTopDark"
      class="logo-image logo-dark"
    />
  </router-link>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import { mapMutations } from "vuex";

export default {
  name: "page-logo",
  props: {
    type: {
      type: String,
      default: "dark"
    }
  },
  components: {
    WpImage
  },
  data() {
    return {
      MQview: null,
      logoType: "dark",
      logoTopDark: WPVUE.options.page_logo,
      logoTopLight: WPVUE.options.page_logo_light
        ? WPVUE.options.page_logo_light
        : WPVUE.options.page_logo
    };
  },
  watch: {},
  computed: {
    logoImageType: {
      set(val) {
        this.logoType = val;
      },
      get() {
        return this.logoType;
      }
    }
  },
  methods: {
    ...mapMutations({
      changeVisiblityMenu: "CHANGE_LOGO_VISIBILITY"
    }),
    checkerFunction(MQvp) {
      if (MQvp.matches) {
        // viewport <= 1199px
        this.logoImageType = "dark";
      } else {
        // viewport > 1199px
        this.logoImageType = this.type;
      }
    },
    checkResolution() {
      const VM = this;
      VM.MQview = window.matchMedia("screen and (max-width: 600px)");
      VM.checkerFunction(VM.MQview);
      VM.MQview.addListener(VM.checkerFunction);
    },
    visibilityChangedLogo(isVisible, entry) {
      this.changeVisiblityMenu(isVisible);
    }
  },
  mounted() {
    this.logoImageType = this.type;
    this.checkResolution();
  },
  destory() {
    this.MQview.removeEventListener(this.checkerFunction);
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.page-logo {
  position: absolute;
  z-index: 21;
  left: 25px;
  top: 25px;
  display: none;
  @include mquery(600px) {
    left: 15px;
    top: 15px;
  }
  .logo-image {
    margin: 0;
    img {
      max-height: 40px;
    }
  }
}
</style>
